<template>
  <Navbar pageName="gp" />
  <Banner :pcBannerList="pcBannerList" :mobileBannerList="mobileBannerList" />

  <template v-if="isMobile">
    <MobileLeadingSupplier />
    <MobileService />
    <MobileProfession />
    <MobileComment />
    <MobilePartner />
    <MobileFooter />
  </template>
  <template v-else>
    <DesktopLeadingSupplier />
    <DesktopService />
    <DesktopProfession />
    <DesktopComment />
    <DesktopPartner />
    <DesktopHonor />
    <DesktopQualification />
    <Feature />
    <DesktopFooter />
  </template>
</template>

<script>
import Banner from '@/shared/components/banner.vue'
import Navbar from '@/shared/components/navbar.vue'
import Feature from '@/shared/components/feature.vue'
import DesktopFooter from '@/shared/components/footer/desktop-footer.vue'
import MobileFooter from '@/shared/components/footer/mobile-footer.vue'
import DesktopLeadingSupplier from './components/leading-supplier/desktop-leading-supplier.vue'
import MobileLeadingSupplier from './components/leading-supplier/mobile-leading-supplier.vue'
import MobileService from './components/service/mobile-service.vue'
import MobileProfession from './components/profession/mobile-profession.vue'
import MobileComment from './components/comment/mobile-comment.vue'
import MobilePartner from './components/partner/mobile-partner.vue'
import DesktopService from './components/service/desktop-service.vue'
import DesktopProfession from './components/profession/desktop-profession.vue'
import DesktopComment from './components/comment/desktop-comment.vue'
import DesktopPartner from './components/partner/desktop-partner.vue'
import DesktopHonor from './components/honor/desktop-honor.vue'
import DesktopQualification from './components/qualification/desktop-qualification.vue'
import { isMobile } from '@/shared/utils/equipment.utils.js'

export default {
  components: {
    Banner,
    DesktopFooter,
    DesktopLeadingSupplier,
    DesktopPartner,
    DesktopComment,
    Feature,
    DesktopHonor,
    DesktopQualification,
    MobileFooter,
    MobileLeadingSupplier,
    MobileProfession,
    MobileService,
    MobileComment,
    MobilePartner,
    DesktopService,
    DesktopProfession,
    Navbar,
  },
  setup() {
    const pcBannerList = [
      './images/gp-banner1.png',
      './images/gp-banner2.png',
      './images/gp-banner3.png',
      './images/index-banner3.png',
    ]
    const mobileBannerList = [
      './images/mobile/gp-banner1.png',
      './images/mobile/gp-banner2.png',
      './images/mobile/gp-banner3.png',
      './images/mobile/index-banner3.png',
    ]

    return { pcBannerList, mobileBannerList, isMobile: isMobile() }
  },
}
</script>
